import { Trans, useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { AlertDialog, Button, ExternalLink } from '~/components';
import { getVatExemptLimitStatus } from '~/utils/user';

type Props = {
  onClose: (isBelowLimit: boolean) => void;
};

export const VatExemptLimitDialog = ({ onClose }: Props) => {
  const { data: user } = useUser();
  const { t } = useTranslation(['invoices']);

  const vatExemptLimitStatus = getVatExemptLimitStatus(user);

  if (vatExemptLimitStatus === 'noLimit' || vatExemptLimitStatus === 'belowLimit') return null;

  if (vatExemptLimitStatus === 'approachingLimit') {
    return (
      <AlertDialog.Body hideCloseButton status="info">
        <AlertDialog.Title>{t('invoices:createEdit.vatExemptLimit.firstWarning.title')}</AlertDialog.Title>

        <AlertDialog.Description>
          <Trans components={{ a: <ExternalLink /> }} i18nKey="invoices:createEdit.vatExemptLimit.firstWarning.description" />
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <Button onClick={() => onClose(true)}>{t('invoices:createEdit.vatExemptLimit.firstWarning.buttonText')}</Button>
        </AlertDialog.Actions>
      </AlertDialog.Body>
    );
  }

  if (vatExemptLimitStatus === 'nearLimit') {
    return (
      <AlertDialog.Body hideCloseButton status="warning">
        <AlertDialog.Title>{t('invoices:createEdit.vatExemptLimit.secondWarning.title')}</AlertDialog.Title>

        <AlertDialog.Description>
          <Trans components={{ a: <ExternalLink /> }} i18nKey="invoices:createEdit.vatExemptLimit.secondWarning.description" />
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <Button onClick={() => onClose(true)}>{t('invoices:createEdit.vatExemptLimit.secondWarning.buttonText')}</Button>
        </AlertDialog.Actions>
      </AlertDialog.Body>
    );
  }

  if (vatExemptLimitStatus === 'overLimit') {
    return (
      <AlertDialog.Body hideCloseButton status="danger">
        <AlertDialog.Title>{t('invoices:createEdit.vatExemptLimit.exceeded.title')}</AlertDialog.Title>

        <AlertDialog.Description>
          <Trans components={{ a: <ExternalLink /> }} i18nKey="invoices:createEdit.vatExemptLimit.exceeded.description" />
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <Button onClick={() => onClose(false)}>{t('invoices:createEdit.vatExemptLimit.exceeded.buttonText')}</Button>
        </AlertDialog.Actions>
      </AlertDialog.Body>
    );
  }

  return null;
};
